/**
 * @Author: abbeymart | Abi Akindele | @Created: 2016-12-15 | @Updated: 2019-04-03
 * @Company: mConnect.biz | @License: MIT
 * @Description: mconnect routes (mconnect.biz main website)
 */

import type { RouteRecordRaw } from 'vue-router';
import { businessRoutes } from 'src/router/mc/businessRoutes';
import { projectRoutes } from 'src/router/mc/projectRoutes';
import { toolkitRoutes } from 'src/router/mc/toolkitRoutes';
import { legalRoutes } from 'src/router/mc/legalRoutes';

const mc: Array<RouteRecordRaw> = [];

export const mcBizRoutes: Array<RouteRecordRaw> = [
  ...mc,
  ...businessRoutes,
  ...projectRoutes,
  ...toolkitRoutes,
  ...legalRoutes,
];
